import {
  SET_EXPERIMENT,
  UPDATE_APPLE_PAY_AVAILABLE,
  UPDATE_GOOGLE_PAY_AVAILABLE,
} from './actionConstants'
import { getExperimentValue } from 'lib/optimize'
import noop from 'lib/noop'

export function getExperiment(experimentID: string) {
  return (dispatch) => {
    getExperimentValue(experimentID).then(value => dispatch({
      type: SET_EXPERIMENT,
      value,
      experimentID,
    }),
    ).catch(noop)
  }
}

export function setServerExperimentValue(experimentID: string, value: string) {
  return (dispatch) => {
    dispatch({
      type: SET_EXPERIMENT,
      value,
      experimentID,
    })
  }
}

export function updateCanPayWithApplePay(flag: boolean) {
  return {
    type: UPDATE_APPLE_PAY_AVAILABLE,
    value: flag,
  }
}

export function updateCanPayWithGooglePay(flag: boolean) {
  return {
    type: UPDATE_GOOGLE_PAY_AVAILABLE,
    value: flag,
  }
}
